var escape = require("../../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3Ol1a2dC-index-module-sp3-logo{background-image:url(" + escape(require("./logo-sp3.png")) + ");background-size:100% auto;display:inline-block;height:62px;width:91px}", ""]);

// exports
exports.locals = {
	"sp3-logo": "_3Ol1a2dC-index-module-sp3-logo",
	"sp3Logo": "_3Ol1a2dC-index-module-sp3-logo"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"localIdentName":"[hash:base64:8]-[name]-[local]","modules":true,"camelCase":true}!../~/postcss-loader/lib!../~/sass-loader/lib/loader.js!./js/components/support/logos/SP3Logo/index.module.scss
// module id = 1213
// module chunks = 0